import { createClient } from "@nwga/auth/client";
import { env } from "../env.ts";

/**
 * The Better Auth browser client.
 *
 * Sign-in, sign-up and sign-out go through here rather than through tRPC:
 * authentication is its own protocol, with its own cookie handling and OAuth
 * redirects, and wrapping it in a procedure would gain nothing.
 *
 * Everything *after* sign-in — who you are, what you may do — comes from the
 * `session` tRPC query, so there is one source of truth for authorization.
 */
export const authClient = createClient({ baseURL: env.apiUrl });

export const { signIn, signUp, signOut, useSession } = authClient;
